import { Icon } from '../Icon';
import { IconType } from '@src/IconType';
import {
  Checkbox as MaterialCheckbox,
  type CheckboxProps as MaterialCheckboxProps,
} from '@material-tailwind/react';
import { classNames } from '@src/utils/classNames';
import { forwardRef } from 'react';
import type { labelProps } from '@material-tailwind/react/types/components/input';

type CheckboxProps = Omit<MaterialCheckboxProps, 'color'> & {
  labelProps?: Partial<labelProps> & { className?: string };
  color?: 'blue' | 'black';
};

export const Checkbox = forwardRef<HTMLInputElement, CheckboxProps>(
  (
    { onChange, label, disabled, checked, labelProps, color, ...rest },
    forwardedRef,
  ) => {
    return (
      <MaterialCheckbox
        crossOrigin={undefined}
        checked={checked}
        onChange={onChange}
        inputRef={forwardedRef}
        label={label}
        disabled={disabled}
        icon={<Icon type={IconType.Check} className="w-4 h-4" />}
        // @ts-expect-error We fixed the colors and it works
        color={color}
        // This is a hack! The peer-checked class does not work here. See https://github.com/creativetimofficial/material-tailwind/issues/839
        iconProps={{
          className: classNames(
            checked ? 'opacity-100' : '',
            color === 'black' ? 'text-black' : '',
          ),
        }}
        labelProps={{
          className: classNames(
            labelProps?.className,
            disabled ? 'text-slate-500' : '',
          ),
          ...labelProps,
        }}
        {...rest}
      />
    );
  },
);
